enum FundSectorBreakdownType {
  MATERIALER = 'Materialer',
  KOMMUNIKASJONSTJENESTER = 'Kommunikasjonstjenester',
  SYKLISK_KONSUM = 'Syklisk_konsum',
  STABILT_KONSUM = 'Stabilt_konsum',
  HELSE = 'Helse',
  INDUSTRI = 'Industri',
  EIENDOM = 'Eiendom',
  TEKNOLOGI = 'Teknologi',
  ENERGI = 'Energi',
  FINANS = 'Finans',
  FORSYING = 'Forsyning',
  ANNET = 'Annet',
  UDEFINERT = 'Udefinert',
}

export default FundSectorBreakdownType;
